<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
      class="screenInput"
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
      class="screenInput"
        filterable
        v-model="screen.patrol_status"
        placeholder="请选择巡检状态"
      >
      <el-option
          label="全部"
          value="-1"
        ></el-option>
        <el-option
          label="正常"
          value="1"
        ></el-option>
        <el-option
          label="违规"
          value="2"
        ></el-option>
        
      </el-select>
      <!-- <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.apply_status"
        placeholder="请选择装修状态"
      >
      <el-option
          label="全部"
          value="-1"
        ></el-option>
        <el-option
          label="正常"
          value="1"
        ></el-option>
        <el-option
          label="违规"
          value="2"
        ></el-option>
        
      </el-select> -->
      <el-input
      class="screenInput"
        v-model="screen.patrol_search"
        placeholder="请输入巡检人姓名/手机号"
        maxlength="11"
      ></el-input>
      <el-input

      class="screenInput"
        v-model="screen.file_no"
        placeholder="请输入档案编号"
      ></el-input>
      <el-input
      class="screenInput"
        v-model="screen.apply_search"
        placeholder="请输入业主人姓名/手机号"
        maxlength="11"
      ></el-input>
      <el-date-picker
      class="screenInput"
      value-format="yyyy-MM-dd"
      v-model="screen.patrol_start_time"
      type="date"
      placeholder="巡检开始日期">
    </el-date-picker>
    <el-date-picker
    
    class="screenInput"
      value-format="yyyy-MM-dd"
      v-model="screen.patrol_end_time"
      type="date"
      placeholder="巡检结束日期">
    </el-date-picker>
      <el-button type="primary" plain @click="reset()">重置</el-button>
      <el-button type="primary" @click="(screen.page = 1), fetchData()">搜索</el-button>
    </div>


    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.park_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="房源类型" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.house_type_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="企业名称" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.company_name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="房间号" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.house_name }}
        </template>
      </el-table-column>
      <el-table-column label="业主姓名" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.legal_name }}
        </template>
      </el-table-column>
      <el-table-column label="业主手机号码" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.legal_phone }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.patrol_status == 1"
            type="success"
            disable-transitions
            >正常</el-tag
          >
          <el-tag v-if="scope.row.patrol_status == 2" type="danger" disable-transitions
            >违规</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="巡检人" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.user_name }}
        </template>
      </el-table-column>
      <el-table-column label="巡检时间" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.patrol_time }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/renovation/punch_detail')"
            >巡检详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="巡检时间" prop="patrol_time">
          <el-input
            class="w4"
            disabled
            v-model="ruleForm.patrol_time"
          ></el-input>
        </el-form-item>

        <el-form-item label="巡检人" prop="user">
          <el-input
            class="w4"
            placeholder="请输入排序"
            v-model="ruleForm.user"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="status" label="巡检状态">
            <el-radio-group disabled v-model="ruleForm.status">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="2">违规</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="remark" label="巡检说明">
            <el-input
            class="w4"
            type="textarea"
            placeholder="巡检说明"
            v-model="ruleForm.remark"
            disabled
          >
          </el-input>
          </el-form-item>
          <el-form-item label="场地图片">
            <el-image
              v-for="(img, ind) in ruleForm.image"
              :key="ind"
              style="width: 120px; height: 40px; margin: 0 5px 5px 0"
              :src="imageOss + img"
              fit="contain"
              :preview-src-list="$pathDispose(ruleForm.image)"
            >
            </el-image>
          </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            @click="drawer = false"
          >
          关闭
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, delImage } from "@/api/index";
import {
  setAdd,
  setEdit,
  setDel,
  punchList,
  punchInfo,

  // intention_user,
} from "@/api/renovation";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        company_id: "",
        park_id: "",
        legal_search: "",
        apply_search: "",
      },
      total: 0,
      ruleForm: {},
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        title: [{ required: true, message: "请输入主题", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      czType: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      screenCompanyList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    reset() {
      this.screen = {
        park_id: "",
        legal_search: "",
        apply_search: "",
        company_id: "",
        page: 1,
        page_size: 15,
        is_page: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 编辑
    handleInfo(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      punchInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          patrol_time: res.data.patrol_time,
          remark:res.data.remark,
          status:res.data.status,
          user:res.data.user.name,
          image:res.data.image
        };
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    fetchData() {
      this.listLoading = true;
      punchList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
</style>
